import { Link } from '@tanstack/react-router'

import { SimpleLogoPageContainer } from '@/components/shared/SimpleLogoPageContainer'
import { Box, Button, Heading, Stack, Text } from '@/components/ui'

export const ResetConfirmed = () => {
  return (
    <SimpleLogoPageContainer centered>
      <Stack gap="12" align="center" boxSize="full">
        <Stack gap="2" align="center">
          <Heading as="h1" fontSize="lg">
            パスワードを再設定しました
          </Heading>
          <Text>新しいパスワードで再ログインしてください。</Text>
        </Stack>
        <Box>
          <Link to="/login">
            <Button as="span" variant="outline">
              ログイン画面
            </Button>
          </Link>
        </Box>
      </Stack>
    </SimpleLogoPageContainer>
  )
}
